import pino from 'pino';

const logger = pino({ name: process.env.PROCESS_NAME || 'enterprise' });
export default logger;
